import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

export type pdpZoomCoordinatesProps = {
  positionX: number;
  positionY: number;
};

const pdpZoomCoordinatesAtom = atom({} as pdpZoomCoordinatesProps);

const useSetPDPZoomCoordinatesAtom = () => useSetAtom(pdpZoomCoordinatesAtom);
const usePDPZoomCoordinatesAtomValue = () =>
  useAtomValue(pdpZoomCoordinatesAtom);
const usePDPZoomCoordinatesAtom = () => useAtom(pdpZoomCoordinatesAtom);

export {
  useSetPDPZoomCoordinatesAtom,
  usePDPZoomCoordinatesAtomValue,
  usePDPZoomCoordinatesAtom
};
